import { Button, Space, Table, Tag } from "antd";
import { Image } from "antd";
import HamburgerNavbar from "../../Components/HamburgerNavbar";
import {
  ArrowRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "../../Styles/batchDetailTable.css";
import { useEffect, useState } from "react";
import apiInstance from "../../services/axiosInstance";
import { useParams } from "react-router-dom";

const BatchDetailTable = () => {
  const [loading, setLoading] = useState(false);
  const [batchData, setBatchData] = useState({});
  const {id} = useParams();
  
  const fetchBatchDetails = async () => {
    setLoading(true);
    apiInstance.get(`/batchcertificate/certificate/batch/${id}`)
      .then((response) => {
        if (!response.status) {
          throw new Error("Network response was not ok");
        }
        return response.data;
      })
      .then((data) => {
        // console.log("data: ", data);
        setLoading(false);
        setBatchData(data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error getting image:", error);
      });
  }

  function handleDownloadCSV() {
    let csvContent = "name,email,fileLink\n"; // Headers

    // Append data to CSV content
    batchData.fields.forEach((field) => {
      csvContent += `${field.name},${field.email},${field.fileLink}\n`;
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a temporary URL to download the CSV file
    let downloadLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.setAttribute("download", `${batchData.batch}.csv`);
    document.body.appendChild(downloadLink);

    // Initiate download
    downloadLink.click();

    // Cleanup
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  }

  useEffect(() => {
    fetchBatchDetails();
  }, [])


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      key: "email",
    },
    {
      title: "Certificate",
      dataIndex: "fileLink",
      key: "fileLink",
      render: (value) => {
        return (
          <Image
            className="batchDetailTable__certificate"
            src={value}
            width={100}
            preview={{
              mask: <div style={{ background: "rgba(0, 0, 0, 0.5)" }} />,
            }}
            alt="Certificate"
          />
        );
      },
    },
    {
      title: "Status",
      key: "emailStatus",
      dataIndex: "emailStatus",
      align: "center",
      render: (value) => {
        if (value !== "failure") {
          return (
            <CheckCircleOutlined style={{ color: "green", fontSize: "18px" }} />
          );
        } else {
          return (
            <CloseCircleOutlined style={{ color: "red", fontSize: "18px" }} />
          );
        }
      },
    },
  ];

  return (
    <div>
      <div>
        <HamburgerNavbar />
      </div>
      <div  className="batchDetailTable__downloadButton">
        <Button type="primary" onClick={handleDownloadCSV}>Download CSV</Button>
      </div>
      <div className="batchDetailTable__table">
        <Table
          loading={loading}
          pagination={false}
          columns={columns}
          dataSource={batchData.fields}
          size="small"
        ></Table>
      </div>
    </div>
  );
};

export default BatchDetailTable;
